/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { css as cssClassName } from 'emotion';
import React, { Component } from 'react';
import Field from 'redux-form/lib/Field';
import Form from 'react-bootstrap/lib/Form';

import { debounce } from '../../modules/debounce.ts';
import Spinner from '../Spinner';
import FieldFormControl from '../FieldFormControl';
import CreateAccountContainer from '../CreateAccountContainer';

import Text from '../../shared/Text';

import styles from '../OnboardingRouter/styles.sass';
import { CarrotIcon } from '../../shared/Icon/components/CarrotIcon';
import { ImportAgreement } from './ImportAgreement';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeader,
  OverlayHeaderSection,
  OverlayContent,
} from './styles';
import { SwitchToAnchorHero } from './SwitchToAnchorHero';
import { Step } from './types';

class ImportCreateAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasChanged: false,
      editingSlug: false,
      createAccountSuccess: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.editingSlug &&
      this.props.onboarding.fetchingVanitySlug &&
      !nextProps.onboarding.fetchingVanitySlug
    ) {
      this.setState({ editingSlug: false });
    }
  }

  componentDidMount() {
    this.props.actions.fetchTempVanitySlugFromPodcastName();
    this.handleChangeVanitySlug = debounce(
      this.onChangeVanitySlug.bind(this),
      500
    );
  }

  // TODO: generic text/input controller that propagates onChanges with deboucnes
  onChangeVanitySlug = value => {
    this.props.handleSubmit();
  };

  render() {
    const {
      rssFeed,
      rssFeedMetadata,
      vanitySlug,
      vanitySlugIsAvailable,
      fetchingVanitySlug,
    } = this.props.onboarding;
    const { stationId, userId, handleSubmit, history, actions } = this.props;
    const { hasChanged, editingSlug, createAccountSuccess } = this.state;

    // redirect away when the user refreshes the page or logs out
    if (!rssFeed || (createAccountSuccess && !userId)) {
      actions.redirectToSwitchPage();
      return null;
    }

    const podcastURLEditor = (
      <Form onSubmit={handleSubmit} inline key="podcastUrlEditor">
        <div className={styles.vanityUrlContainer}>
          <p>
            <strong>anchor.fm/</strong>
          </p>
          <Field
            defaultValue={vanitySlug}
            name="vanitySlug"
            component={FieldFormControl}
            type="text"
            onInputChange={e => {
              if (!this.state.hasChanged || !this.state.editingSlug) {
                this.setState({ hasChanged: true, editingSlug: true });
              }
              this.handleChangeVanitySlug(e);
            }}
          />
        </div>
        <div className={styles.vanityUrlInfo}>
          {fetchingVanitySlug || editingSlug ? (
            <Spinner color="gray" size={19} />
          ) : !hasChanged ? (
            <p className={styles.vanityUrlTip}>
              Tip: you can customize this URL.
            </p>
          ) : vanitySlugIsAvailable ? (
            <p style={{ color: '#27DE56' }}>Looks good!</p>
          ) : (
            <p style={{ color: '#FF6663' }}>Sorry, that URL is unavailable.</p>
          )}
        </div>
      </Form>
    );

    return (
      <Wrapper>
        <SwitchToAnchorHero
          imageSrc={rssFeedMetadata.image}
          authorName={rssFeedMetadata.authorName}
        />
        <OverlayWrapper>
          <Overlay>
            <OverlayHeaderSection>
              <OverlayHeader>Create your account</OverlayHeader>
              <div
                css={css`
                  text-align: center;
                `}
              >
                <Text
                  size="md"
                  isInline
                  isBold
                  color={createAccountSuccess ? '#a0a0a0' : '#15171a'}
                >
                  Sign up
                </Text>
                <CarrotIcon
                  className={cssClassName`width: 5px; margin: 0 5px;`}
                />
                <Text
                  size="md"
                  isInline
                  isBold
                  color={createAccountSuccess ? '#15171a' : '#a0a0a0'}
                >
                  Import podcast
                </Text>
              </div>
            </OverlayHeaderSection>
            <OverlayContent>
              {createAccountSuccess ? (
                <ImportAgreement
                  stationId={stationId}
                  userId={userId}
                  feedUrl={rssFeed}
                  previousStep={Step.CREATE_ACCOUNT}
                  history={history}
                  resetPersistedState={actions.resetPersistedState}
                />
              ) : (
                <div
                  css={css`
                    max-width: 342px;
                  `}
                >
                  {podcastURLEditor}
                  <CreateAccountContainer
                    submitCallback={() =>
                      this.setState({ createAccountSuccess: true })
                    }
                  />
                </div>
              )}
            </OverlayContent>
          </Overlay>
        </OverlayWrapper>
      </Wrapper>
    );
  }
}

export default ImportCreateAccount;
